export const getYears = () => {
  const startYear = 1970;
  const endYear = new Date().getFullYear();

  const dateArray = [];

  for (let i = startYear; i <= endYear; i++) {
    dateArray.push(i.toString());
  }

  return dateArray;
};
